import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_2 = { class: "flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_5 = { class: "container p-0" }
const _hoisted_6 = { class: "row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Address", -1)
const _hoisted_8 = { class: "row mb-10" }
const _hoisted_9 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Bedrooms", -1)
const _hoisted_11 = {
  class: "col-sm",
  style: {"padding-right":"0px"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Beds", -1)
const _hoisted_13 = { class: "row mb-10" }
const _hoisted_14 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Floor", -1)
const _hoisted_16 = {
  class: "col-sm",
  style: {"padding-right":"0px"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlInput1",
  class: "required form-label"
}, "Choices", -1)
const _hoisted_18 = { class: "row mb-10" }
const _hoisted_19 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_20 = { class: "card card-flush" }
const _hoisted_21 = {
  class: "card-header pt-7",
  id: "kt_chat_contacts_header"
}
const _hoisted_22 = { class: "container p-0" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  class: "col-sm",
  style: {"padding-left":"0px"}
}
const _hoisted_25 = {
  for: "exampleFormControlInput1",
  class: "form-label",
  style: {"padding-left":"10px"}
}
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "address",
                id: "exampleFormControlInput1",
                class: "form-control form-control-solid",
                placeholder: "Address",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.address) = $event))
              }, null, 512), [
                [_vModelText, _ctx.formData.address]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.bedrooms) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.bedrooms]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.beds) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.beds]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.floor) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.floor]
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  id: "exampleFormControlInput1",
                  class: "form-control form-control-solid",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.choices) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.choices]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.requestNewAdvert && _ctx.requestNewAdvert(...args))),
                class: "btn btn-primary"
              }, "Submit")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (_ctx.advert.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advert, (adv, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "row mb-5"
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("label", _hoisted_25, "Advert " + _toDisplayString(index+1), 1),
                        _withDirectives(_createElementVNode("textarea", {
                          type: "text",
                          id: "exampleFormControlInput1",
                          class: "form-control form-control-solid",
                          placeholder: "Title",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.advert[index]) = $event),
                          rows: "8",
                          "max-rows": "10"
                        }, null, 8, _hoisted_26), [
                          [_vModelText, _ctx.advert[index]]
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, "Fill the Form and Submit to generate Advert's"))
          ])
        ])
      ])
    ])
  ]))
}